export default __webpack_public_path__ + "static/media/exit.611ef233.svg";